export type NewsTagCategory = 'game-version' | 'section' | 'global'

export interface NewsTag {
  id: string
  label: string
  category: NewsTagCategory
  color: string
}

export const NEWS_TAGS: NewsTag[] = [
  {
    id: 'global',
    label: 'Global',
    category: 'global',
    color: 'var(--color-tag-global)',
  },
  {
    id: 'live',
    label: 'Live',
    category: 'game-version',
    color: 'var(--color-tag-live)',
  },
  {
    id: 'classic_progression',
    label: 'Classic',
    category: 'game-version',
    color: 'var(--color-tag-classic-progression)',
  },
  {
    id: 'classic_anniversary',
    label: 'Anniversary',
    category: 'game-version',
    color: 'var(--color-tag-classic-anniversary)',
  },
  {
    id: 'classic_era',
    label: 'Era',
    category: 'game-version',
    color: 'var(--color-tag-classic-era)',
  },
  {
    id: 'roster',
    label: 'Roster',
    category: 'section',
    color: 'var(--color-tag-roster)',
  },
  {
    id: 'loot',
    label: 'Loot',
    category: 'section',
    color: 'var(--color-tag-loot)',
  },
  {
    id: 'events',
    label: 'Events',
    category: 'section',
    color: 'var(--color-tag-events)',
  },
  {
    id: 'recruitment',
    label: 'Recruitment',
    category: 'section',
    color: 'var(--color-tag-recruitment)',
  },
  {
    id: 'notifications',
    label: 'Notifications',
    category: 'section',
    color: 'var(--color-tag-notifications)',
  },
  {
    id: 'api',
    label: 'API',
    category: 'section',
    color: 'var(--color-tag-api)',
  },
]

const tagsById = new Map(NEWS_TAGS.map((tag) => [tag.id, tag]))

export const tagLabel = (id: string): string => tagsById.get(id)?.label ?? id

export const tagColor = (id: string): string | undefined =>
  tagsById.get(id)?.color
